import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-use-window-localstorage/react-use-window-localstorage/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { UseClearExample } from '../__docz__/components/UseClearExample';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>useClearLocalStorage</h1>
    <h2 {...{
      "id": "description"
    }}>{`Description`}</h2>
    <p>{`This hook calls `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage"
      }}>{`localStorage.clear()`}</a>{` to clear all items from `}<inlineCode parentName="p">{`localStorage`}</inlineCode>{`. `}</p>
    <p>{`All hooks will be reset back to their default values, or to `}<inlineCode parentName="p">{`null`}</inlineCode>{` if none was provided.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { useClearLocalStorage } from 'react-use-window-localstorage';
`}</code></pre>
    <p>{`In your function component:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const clearLocalStorage = useClearLocalStorage();
`}</code></pre>
    <p>{`Call `}<inlineCode parentName="p">{`clearLocalStorage()`}</inlineCode>{` to clear localStorage.`}</p>
    <h2 {...{
      "id": "signature"
    }}>{`Signature`}</h2>
    <p><inlineCode parentName="p">{`useClearLocalStorage() => (() => void)`}</inlineCode></p>
    <h3 {...{
      "id": "props"
    }}>{`Props`}</h3>
    <p>{`The hook takes no props.`}</p>
    <h3 {...{
      "id": "return"
    }}>{`Return`}</h3>
    <p>{`The hook returns a function, `}<inlineCode parentName="p">{`clearLocalStorage`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`clearLocalStorage() => void
`}</code></pre>
    <p>{`Calling this function clears localStorage and synchronizes all hooks.`}</p>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`In the following example, four numbers are defaulted to `}<inlineCode parentName="p">{`0`}</inlineCode>{` and can be set to randomly generated values. The fifth value has no default. Calling `}<inlineCode parentName="p">{`clearLocalStorage()`}</inlineCode>{` will clear
localStorage using `}<inlineCode parentName="p">{`localStorage.clear()`}</inlineCode>{` and synchronize all hooks.`}</p>
    <div style={{
      border: 'solid 2px #67788a',
      padding: '20px'
    }}>
  <UseClearExample mdxType="UseClearExample" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import * as React from 'react';
import { useClearLocalStorage, useLocalStorageNumber } from 'react-use-window-localstorage';

export function UseClearExample() {
  const [val1, setVal1] = useLocalStorageNumber('val1', 0);
  const [val2, setVal2] = useLocalStorageNumber('val2', 0);
  const [val3, setVal3] = useLocalStorageNumber('val3', 0);
  const [val4, setVal4] = useLocalStorageNumber('val4', 0);
  const [val5, setVal5] = useLocalStorageNumber('val5');
  const clearLocalStorage = useClearLocalStorage();

  return (
    <div>
      <div>
        <div>
          <strong>Stored values:</strong>
          <ul>
            <li>val1: {val1}</li>
            <li>val2: {val2}</li>
            <li>val3: {val3}</li>
            <li>val4: {val4}</li>
            <li>val5 (no default): {val5}</li>
          </ul>
        </div>
      </div>
      <div>
        <button
          onClick={() => {
            setVal1(Math.random());
            setVal2(Math.random());
            setVal3(Math.random());
            setVal4(Math.random());
            setVal5(Math.random());
          }}
        >
          Generate Random Values
        </button>
      </div>
      <div>
        <button onClick={() => clearLocalStorage()}>Clear</button>
      </div>
    </div>
  );
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      